import { AbsoluteFill, Img, interpolate, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import './assets/css/TuPlan.css'
import { useEffect } from "react";

interface SeccionInterface {
	cuotasText: string,
	cuotasSteps: number[],
	cuotasPosicion: number,
	title: string,
	subtitle: string,
	text: string,
	month: string
}

export const TuPlanSection = ({
	cuotasText,
	cuotasPosicion,
	cuotasSteps,
	title,
	subtitle,
	text,
	month
}: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_PHONE.png"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/BOX_PORCENTAJE.png"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/PATTERN_PROGRESS.png"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);

	const cantidadPasos = cuotasSteps?.length;

	const scalePhoneSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 1,
		to: 2.5,
		delay: (durationInFrames - 20)
	});
	const translateXphone = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 63,
		delay: (durationInFrames - 20)
	});
	const translateYphone = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 70,
		delay: (durationInFrames - 20)
	});
	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 2,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 10,
		delay: (durationInFrames - 8)
	});


	const scalePhone = spring({
		fps,
		frame: frame * 3,
		config: { damping: 1, stiffness: 1 },
		from: 0,
		to: 1,
		delay: 0
	});
	const numeroCuotas = cuotasPosicion + 1;

	// ? CAJA ANIMATION

	const cuentaCuotas = spring({
		fps,
		frame,
		config: { damping: 50, stiffness: 20 },
		from: 0,
		to: numeroCuotas,
		delay: 20
	});

	const cajaScale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 10
	});

	const cajaRotate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -45,
		to: 0,
		delay: 10
	});

	const cajaTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 35,
		to: 0,
		delay: 10
	});
	const posicionCuota = cuotasSteps.indexOf(cuotasPosicion);
	const obtenerValorPorcentual = (100 / cantidadPasos);
	const obtenerPorcentaje = (posicionCuota + 1) * obtenerValorPorcentual;
	const ajustePorcentaje = (posicionCuota * 0.1);
	const cajaPorcentajeProgreso = spring({
		fps,
		frame,
		config: { damping: 50, stiffness: 10 },
		from: 0,
		to: obtenerPorcentaje + ajustePorcentaje,
		delay: 20
	});
	const cajaPorcentajeMenos = spring({
		fps,
		frame,
		config: { damping: 50, stiffness: 10 },
		from: 0,
		to: 126,
		delay: 20
	});

	const cajaTextOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 15
	});

	const translateCuota1 = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 5
	});
	const opacityCuota1 = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 5
	});

	const translatePlan = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 85
	});
	const opacityPlan = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 85
	});
	const translatePlan2 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 90
	});
	const opacityPlan2 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 90
	});
	const translatePlan3 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 100
	});
	const opacityPlan3 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 100
	});

	const translatePlan4 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 115
	});
	const widthPlan4 = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 100,
		to: 390,
		delay: 115
	});
	const opacityPlan4 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 115
	});
	const opacityPlan5 = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 125
	});

	// ? BARRA ANIMATION

	const barraWidthAnimation = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 10,
		to: 100,
		delay: 5
	});

	const barraOpacityAnimation = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});

	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="phone" style={{
					position: "absolute",
					top: "50%",
					left: -60,
					zIndex: 1,
					transform: `translateY(-50%) scale(${scalePhone})`,
				}}>
					<Img className="phone" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/02_PHONE.png")} style={{
						transform: `translate(${translateXphone}%, ${translateYphone}%) scale(${scalePhoneSection})`,
					}} />
				</div>
				<div className="cuotas" style={{
					position: "absolute",
					right: 110,
					top: 300,
					opacity: 1,
					maxWidth: 1098,
					minWidth: 1098,
				}}>
					<div className="caja"
						style={{
							backgroundImage: `url(${staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/BOX_PORCENTAJE.png")})`,
							backgroundSize: "100% 100%",
							backgroundRepeat: "no-repeat",
							position: "absolute",
							bottom: "100%",
							left: `calc(${cajaPorcentajeProgreso}% - ${cajaPorcentajeMenos}px)`,
							width: 242,
							height: 227,
							transformOrigin: "bottom",
							transform: `scale(${cajaScale}) rotate(${cajaRotate}deg) translateY(${cajaTranslate}px)`,
						}}>
						<div className="numero" style={{
							position: "absolute",
							top: 60,
							left: "50%",
							fontSize: 67,
							color: "#fff",
							opacity: cajaTextOpacity,
							fontWeight: "bold",
							transform: "translateX(-50%)",
						}}>{parseInt(String(cuentaCuotas))}</div>
					</div>
					<div className="barra" style={{
						backgroundColor: "#000",
						position: "relative",
						border: "5px solid #fff",
						minHeight: 62,
						width: `${barraWidthAnimation}%`,
						opacity: barraOpacityAnimation,
						borderRadius: 35,
						overflow: "hidden",
						boxShadow: "0 0 0.5rem #fff, inset 0 0 0.5rem #fff, 0 0 2rem #FF0000, inset 0 0 2rem #FF0000, 0 0 4rem #FF0000, inset 0 0 4rem #FF0000",
					}}>
						<div className="pattern" style={{
							backgroundImage: `url(${staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/PATTERN_PROGRESS.png")})`,
							backgroundSize: "1000px 62px",
							position: "absolute",
							width: "100%",
							height: "100%",
							left: 0,
							top: 0,
							opacity: 0.4,
							animation: "bgLeft 10s linear infinite"
						}}></div>
						<div className="progreso" style={{
							backgroundColor: "#E6E6E6",
							position: "absolute",
							width: `${cajaPorcentajeProgreso}%`,
							height: "100%",
							left: 0,
							top: 0,
							borderRadius: "35px 0 0 35px",
							borderTop: "10px solid rgb(255 255 255 / 30%)",
							borderBottom: "10px solid rgb(128 128 128 / 40%)",
						}}></div>
					</div>
					<div className="steps" style={{
						position: "relative",
						display: "flex",
						fontSize: 38,
						color: "#fff",
						marginTop: 35,
						lineHeight: 1,
						fontWeight: "bold",
						justifyContent: "space-between"
					}}>
						<div className="step" style={{
							textAlign: "center",
							opacity: opacityCuota1,
							maxWidth: 125,
							transform: `translateY(${translateCuota1}px)`,
						}}>{cuotasText}</div>
						{cuotasSteps.map((value, index) => {
							const currentIndex = index + 1;
							const currentTranslate = spring({
								fps,
								frame,
								config: { damping: 100, stiffness: 100 },
								from: -30,
								to: 0,
								delay: 10 + (currentIndex * 5)
							});
							const currentOpacity = spring({
								fps,
								frame,
								config: { damping: 100, stiffness: 100 },
								from: 0,
								to: 1,
								delay: 10 + (currentIndex * 5)
							});
							const obtenerValorPorcentual = (100 / cantidadPasos);
							const currentPosicion = currentIndex * obtenerValorPorcentual;
							const estilos: React.CSSProperties = {
								position: "absolute",
								fontSize: 45,
								opacity: currentOpacity,
								transform: `translateY(${currentTranslate}px)`, 
							};
							if (cantidadPasos != currentIndex) {
								estilos.left = `${currentPosicion}%`;
							} else {
								estilos.right = '0';
							}
							return (
								<div key={value} className={`step${cantidadPasos != currentIndex ? " break" : ""}`} style={estilos}>
									<div className="line"></div>
									<div className="text" style={{
										left: "50%",
										transform: "translate(-50%)"
									}}>{value}</div>
								</div>
							);
						})}
					</div>
				</div>
				<div className="tu_plan" style={{
					position: "absolute",
					right: 280,
					bottom: 180,
					textAlign: "center"
				}}>
					<h1 style={{
						margin: 0,
						fontSize: 61,
						fontWeight: "bold",
						color: "#fff",
						lineHeight: 1,
						marginBottom: 25,
						opacity: opacityPlan,
						transform: `translateY(${translatePlan}px)`
					}}>{title}</h1>
					<h2 style={{
						margin: 0,
						fontSize: 61,
						fontWeight: 300,
						color: "#fff",
						lineHeight: 1,
						opacity: opacityPlan2,
						transform: `translateY(${translatePlan2}px)`
					}}>{subtitle}</h2>
					<div className="finaliza" style={{
						display: "flex",
						alignItems: "center",
						marginTop: 48,
						gap: 44,
						justifyContent: "center"
					}}>
						<span style={{
							position: "relative",
							fontSize: 61,
							fontWeight: "bold",
							color: "#fff",
							opacity: opacityPlan3,
							transform: `translateX(${translatePlan3}px)`
						}}>{text}</span>
						<div className="caja">
							<div className="mes" style={{
								backgroundColor: "#000",
								fontWeight: "bold",
								fontSize: 47,
								color: "#fff",
								width: widthPlan4,
								minHeight: 93,
								display: "flex",
								borderRadius: 16,
								alignItems: "center",
								padding: "0.5rem 1rem",
								border: "4px solid #fff",
								justifyContent: "center",
								textTransform: "uppercase",
								opacity: opacityPlan4,
								transform: `translateX(${translatePlan4}px)`,
								boxShadow: "0 0 0.5rem #fff, inset 0 0 0.5rem #fff, 0 0 2rem #FF0000, inset 0 0 2rem #FF0000, 0 0 4rem #FF0000, inset 0 0 4rem #FF0000",
							}}>
								<span style={{
									opacity: opacityPlan5,
								}}>{month}</span>
							</div>
						</div>
					</div>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};